import {
	WARRANTY_CLAIMS_LIST_FILTERED,
	WARRANTY_CLAIMS_LIST_FILTERED_SUCCESS,
	WARRANTY_CLAIMS_LIST_FILTERED_ERROR,
	WARRANTY_CLAIMS_IMPORT,
	WARRANTY_CLAIMS_IMPORT_SUCCESS,
	WARRANTY_CLAIMS_IMPORT_ERROR,
	WARRANTY_CLAIMS_ARCHIVE,
	WARRANTY_CLAIMS_ARCHIVE_SUCCESS,
	WARRANTY_CLAIMS_ARCHIVE_ERROR,
	WARRANTY_CLAIMS_UNARCHIVE,
	WARRANTY_CLAIMS_UNARCHIVE_SUCCESS,
	WARRANTY_CLAIMS_UNARCHIVE_ERROR,
} from "../actions/warrantyClaims";
import WarrantyClaimsService from '@/services/warrantyClaims';

const state = {
	status: '',
};

const getters = {
};

const actions = {
	[WARRANTY_CLAIMS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.invoiceNumber) {
			requestData.invoiceNumberFilter = data.tableProps.inputFilter.invoiceNumber;
		}
		if (data.tableProps.inputFilter.invoiceDate) {
			requestData.invoiceDateFilter = data.tableProps.inputFilter.invoiceDate;
		}
		if (data.tableProps.inputFilter.orderNumber) {
			requestData.orderNumberFilter = data.tableProps.inputFilter.orderNumber;
		}
		if (data.tableProps.inputFilter.customerNumber) {
			requestData.customerNumberFilter = data.tableProps.inputFilter.customerNumber;
		}
		if (data.tableProps.inputFilter.ordererTitle) {
			requestData.ordererTitleFilter = data.tableProps.inputFilter.ordererTitle;
		}
		if (data.tableProps.inputFilter.showArchived) {
			requestData.showArchived = data.tableProps.inputFilter.showArchived;
		}
		return new Promise((resolve, reject) => {
			commit(WARRANTY_CLAIMS_LIST_FILTERED);
			WarrantyClaimsService.listFiltered(requestData)
				.then(responseData => {
					commit(WARRANTY_CLAIMS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(WARRANTY_CLAIMS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
	[WARRANTY_CLAIMS_IMPORT]: ({ commit }, formData) => {
		return new Promise((resolve, reject) => {
			commit(WARRANTY_CLAIMS_IMPORT);
			WarrantyClaimsService.import(formData)
				.then(responseData => {
					commit(WARRANTY_CLAIMS_IMPORT_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(WARRANTY_CLAIMS_IMPORT_ERROR, error);
					reject(error);
				});
		});
	},
	[WARRANTY_CLAIMS_ARCHIVE]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(WARRANTY_CLAIMS_ARCHIVE);
			WarrantyClaimsService.archive(requestData)
				.then(data => {
					commit(WARRANTY_CLAIMS_ARCHIVE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(WARRANTY_CLAIMS_ARCHIVE_ERROR, error);
					reject(error);
				});
		});
	},
	[WARRANTY_CLAIMS_UNARCHIVE]: ({ commit, dispatch }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(WARRANTY_CLAIMS_UNARCHIVE);
			WarrantyClaimsService.unarchive(requestData)
				.then(data => {
					commit(WARRANTY_CLAIMS_UNARCHIVE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(WARRANTY_CLAIMS_UNARCHIVE_ERROR, error);
					reject(error);
				});
		});
	},
};

const mutations = {
	[WARRANTY_CLAIMS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[WARRANTY_CLAIMS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[WARRANTY_CLAIMS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[WARRANTY_CLAIMS_IMPORT]: state => {
		state.status = 'loading';
	},
	[WARRANTY_CLAIMS_IMPORT_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[WARRANTY_CLAIMS_IMPORT_ERROR]: state => {
		state.status = 'error';
	},
	[WARRANTY_CLAIMS_ARCHIVE]: state => {
		state.status = 'loading';
	},
	[WARRANTY_CLAIMS_ARCHIVE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[WARRANTY_CLAIMS_ARCHIVE_ERROR]: state => {
		state.status = 'error';
	},
	[WARRANTY_CLAIMS_UNARCHIVE]: state => {
		state.status = 'loading';
	},
	[WARRANTY_CLAIMS_UNARCHIVE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[WARRANTY_CLAIMS_UNARCHIVE_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};